let isSpotMode = false;
let isDarkMode = false;
const spotModeToggle = document.getElementById('spotModeToggle');
const darkModeToggle = document.getElementById('darkModeToggle');
const inputArray = document.getElementById('inputArray');
const outputArray = document.getElementById('outputArray');
const navbarTitle = document.getElementById('navbarTitle');
const pageTitle = document.getElementById('pageTitle');
const inputLabel = document.getElementById('inputLabel');
const outputLabel = document.getElementById('outputLabel');
// Restore saved modes from cookies
const savedSpotMode = getCookie('spotMode') === 'true';
const savedDarkMode = getCookie('darkMode') === 'true';
if (savedSpotMode) toggleSpotMode(true);
if (savedDarkMode) toggleDarkMode(true);
// Toggle Spot Mode
spotModeToggle.addEventListener('click', ()=>{
    toggleSpotMode(!isSpotMode);
});
// Toggle Dark Mode
darkModeToggle.addEventListener('click', ()=>{
    toggleDarkMode(!isDarkMode);
});
// Handle input change
inputArray.addEventListener('input', ()=>{
    if (isSpotMode) handleSpotMode();
    else handleArrayMode();
});
// Copy to Clipboard
document.getElementById('copyButton').addEventListener('click', ()=>{
    outputArray.select();
    document.execCommand('copy');
});
// Clear Input
document.getElementById('clearButton').addEventListener('click', ()=>{
    inputArray.value = ''; // Clear the content of the input textarea
});
// Set text based on mode
function setModeText() {
    spotModeToggle.innerText = isSpotMode ? 'Array Mode' : 'Spot Mode';
    navbarTitle.innerText = isSpotMode ? 'Spot Reformatter' : 'Array Reformatter';
    pageTitle.innerText = isSpotMode ? 'Spot Reformatter' : 'Array Reformatter';
    inputLabel.innerText = isSpotMode ? 'Input Arrays:' : 'Input Array:';
    outputLabel.innerText = isSpotMode ? 'Output Table:' : 'Output Column:';
    if (isSpotMode) {
        // Populate Spot Mode headers
        outputArray.value = 'Spots\tlocal min 1\tmax\tlocal min 2\tcoord\n';
        handleSpotMode();
    } else {
        outputArray.value = ''; // Clear output in Array Mode
        handleArrayMode();
    }
}
// Handle Array Mode parsing
function handleArrayMode() {
    const values = inputArray.value.replace(/[\[\]]/g, '') // Remove square brackets
    .split(',') // Split by commas
    .map((item)=>item.trim()) // Trim whitespace from each item
    .map((item)=>item.toLowerCase() === 'nan' ? '0' : item); // Replace "nan" (case-insensitive) with "0"
    outputArray.value = values.join('\n'); // Join values with line breaks
}
// Toggle Spot Mode
function toggleSpotMode(state) {
    isSpotMode = state;
    setCookie('spotMode', state, 7);
    setModeText();
}
// Toggle Dark Mode
function toggleDarkMode(state) {
    isDarkMode = state;
    darkModeToggle.innerText = isDarkMode ? 'Light Mode' : 'Dark Mode';
    // Update the title dynamically based on mode
    document.title = isDarkMode ? "Chlo\xe9's Cave" : "Chlo\xe9's Corner";
    // Add or remove the 'dark-mode' class for all relevant elements
    document.body.classList.toggle('dark-mode', isDarkMode);
    document.querySelector('.navbar').classList.toggle('dark-mode', isDarkMode);
    document.querySelector('.container').classList.toggle('dark-mode', isDarkMode);
    document.querySelectorAll('textarea').forEach((textarea)=>textarea.classList.toggle('dark-mode', isDarkMode));
    document.querySelectorAll('label').forEach((label)=>label.classList.toggle('dark-mode', isDarkMode));
    document.querySelectorAll('button').forEach((button)=>button.classList.toggle('dark-mode', isDarkMode));
    pageTitle.classList.toggle('dark-mode', isDarkMode);
    // Save preference in a cookie
    setCookie('darkMode', isDarkMode, 7);
}
// Handle Spot Mode parsing
function handleSpotMode() {
    const inputLines = inputArray.value.split('\n');
    const rows = [];
    for(let i = 0; i < inputLines.length; i += 2){
        const spotLine = inputLines[i]?.trim();
        const coordLine = inputLines[i + 1]?.trim();
        if (spotLine?.startsWith('Spot:') && coordLine?.startsWith('Coord:')) {
            // Extract Spot values
            const spotMatch = spotLine.match(/\[([^\]]+)\]/);
            const spotValues = spotMatch ? spotMatch[1].split(',').map((s)=>s.trim()) : [];
            // Extract Coord values
            const coordValues = coordLine.split('Coord:')[1]?.trim();
            if (spotValues.length >= 4 && coordValues) rows.push(`\t${spotValues[0]}\t${spotValues[1]}\t${spotValues[2]}\t${spotValues[4]}\t${coordValues}`);
        }
    }
    // Set output: Headers + rows
    outputArray.value = 'Spots\tlocal min 1\tmax\tlocal min 2\tmax degree\tCoord\n' + rows.join('\n');
}
// Utility: Set cookie
function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 86400000);
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}
// Utility: Get cookie
function getCookie(name) {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find((row)=>row.startsWith(name));
    return cookie ? cookie.split('=')[1] : null;
}

//# sourceMappingURL=reformat.d2ca774c.js.map
